<template>
  <v-row dense>
    <v-col cols="12">
      <v-select
        v-model="form.service_id"
        name="service_id"
        item-text="title"
        item-value="id"
        :items="services"
        :readonly="readonly"
        :label="`${$t('ABO_SERVICES.ITEM')} *`"
        :rules="getRulesByName('service_id')"
        :error-messages="errors.service_id"
        clearable
        @change="updateValue('service_id', $event)"
      />
    </v-col>
    <v-col cols="12">
      <subscription-edit-form
        v-model="form"
        :action="action"
        :person-id="personId"
        :errors="errors"
        :readonly="readonly"
        @input="emitter"
        @update-prop="updateProp(...arguments)"
      />
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex';
import { notEmpty } from '@/modules/_global/variables/rules';
import formEditable from '@/modules/_global/mixins/form-editable';
import SubscriptionEditForm from './SubscriptionEditForm';
import { ACTIVE } from '@/modules/abo_services/common/statuses';

export default {
  name: 'SubscriptionCreateForm',

  components: {
    SubscriptionEditForm
  },

  mixins: [formEditable],

  props: SubscriptionEditForm.props,

  data() {
    return {
      menuFrom: false,
      form: {
        service_id: '',
        from: ''
      },
      rules: {
        service_id: [notEmpty]
      },
      services: []
    };
  },

  mounted() {
    this.getAboServicesFilterList({ status: ACTIVE }).then(({ data }) => {
      this.services = data.data;
    });
  },

  methods: {
    ...mapActions('subscription', ['getAboServicesFilterList'])
  }
};
</script>
